"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoElementStyles = exports.VIDEO_SPACING = void 0;
const styles = {
    root: {
        height: "inherit",
        position: "relative",
        width: "100%",
        display: "grid",
        gridTemplateRows: "minmax(0, 1fr) auto",
    },
};
// export const carouselSlideStyles: CarouselSlideStyleProps = {
//   disconnectedWrapper: {
//     height: "inherit",
//     width: "100%",
//     position: "relative",
//     background: "rgba(29, 29, 29, 0.4)",
//     backdropFilter: "blur(3.40008px)",
//   },
//   disconnected: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "inherit",
//     width: "100%",
//     color: "#fff",
//   },
// };
exports.VIDEO_SPACING = 16;
const getVideoElementStyles = ({ containerHeight, containerWidth, playersCount, }) => {
    if (containerHeight === 0 || containerWidth === 0)
        return { root: { width: "100%", height: "100%" } };
    if (playersCount === 1) {
        return {
            root: {
                width: "100%",
                height: `${containerHeight}px`,
                "@media only screen and (max-width: 768px)": {
                    width: "100%",
                    height: "auto",
                },
            },
        };
    }
    const marginOfError = 2;
    return {
        root: {
            width: `${(containerWidth - exports.VIDEO_SPACING - marginOfError) / 2}px`,
            height: `${(containerHeight - exports.VIDEO_SPACING - marginOfError) / 2}px`,
            "@media only screen and (max-width: 768px)": {
                width: "100%",
                height: "auto",
            },
        },
    };
};
exports.getVideoElementStyles = getVideoElementStyles;
exports.default = styles;
//# sourceMappingURL=styles.js.map